import { TipoFundoInvestimento, PrazoFundoInvestimento, ContaBancaria } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from "../comum/exercicio.model";
import { Orgao } from "../comum/orgao.model";
import { AgenteFundo } from './agente-fundo.model';
import { EnquadramentoFundo } from './enquadramento-fundo.model';

export class FundoInvestimento extends BaseResourceModel {
  constructor(
    public codigo?: number,
    public tipo?: TipoFundoInvestimento,
    public nome?: string,
    public cnpj?: string,
    public enquadramento?: EnquadramentoFundo,
    public limite_percentual?: number,
    public percentual_investido?: number,
    public percentual_autorizado?: number,
    public patrimonio_liquido?: number,
    public moeda?: string,
    public qtd_cotista?: number,
    public tipo_prazo?: PrazoFundoInvestimento,
    public prazo_data?: Date,
    public prazo_periodo?: number,
    public data_aplicacao_inicial?: Date,
    public valor_aplicacao_inicial?: number,
    public qtd_cota_inicial?: number,
    public valor_cota_inicial?: number,
    public observacao?: string,
    public itens?: AgenteFundo[],
    public exercicio?: Exercicio[],
    public conta?: ContaBancaria,
    public orgao?: Orgao[],
  ) {
    super();
  }
  static converteJson(json: any): FundoInvestimento {
    return Object.assign(new FundoInvestimento(), json);
  }
}